import { IMilestoneTemplate } from "@/interfaces";

export const findTargetGeneration = (
  milestones: IMilestoneTemplate[],
  target: IMilestoneTemplate
): number => {
  const generation = 1;
  return findTargetGenerationRecursive(milestones, target, generation);
};

const findTargetGenerationRecursive = (
  milestones: IMilestoneTemplate[],
  target: IMilestoneTemplate,
  generation: number
): number => {
  const foundParent = milestones.find(({ id }) => id === target.id);

  if (foundParent) return generation;

  for (const milestone of milestones) {
    if (!milestone.childMilestones?.length) continue;

    const nextGeneration = findTargetGenerationRecursive(
      milestone.childMilestones,
      target,
      generation + 1
    );

    if (generation < nextGeneration) {
      generation = nextGeneration;
      break;
    }
  }
  return generation;
};
